import React from "react";
import { Text, View } from "react-native";
import { t } from "react-native-tailwindcss";
import Box from "../../../atoms/Box";
import Card from "../../../atoms/Card";
import { BankAccount } from "../../../../services/bankService";
import { HStack } from "../../../layout/HStack";
import { VStack } from "../../../layout/VStack";

export const RoundupAccount = ({
  account,
  checked,
  updateAccount,
}: {
  account: BankAccount;
  checked: boolean;
  updateAccount: (accountId: string, enabled: boolean) => void;
}): React.ReactElement => {
  const setRoundUps = async () => {
    updateAccount(account.id, !account.activeRoundUpsEnabled);
  };

  return (
    <HStack>
      <Card style={styles.item} key={account.id}>
        <View style={t.wFull}>
          <Text style={{ fontSize: 12, fontWeight: '500' }}>{account.name}   {account.accountNumber}</Text>
          <Text style={[t.pB2, { fontSize: 11 }]}>
            Account Type:{" "}
            <Text style={{ textTransform: "capitalize" }}>
              {account.accountType}
            </Text>
          </Text>
        </View>
      </Card>
      <HStack style={{ width: 50, paddingLeft: 10 }}>
        <VStack>
          <View style={[t.mB5, t.mR0]}>
            <Box checked={checked} onPress={() => setRoundUps()} />
          </View>
        </VStack>
      </HStack>
    </HStack>
  );
};

const styles = {
  container: [t.flex1, t.bgGray200],
  heading: [t.mY8, t.textCenter],
  // itemContainer: [t.flex, t.flexCol, t.flex1],
  item: [t.w5_6, t.pB3, t.pT0, t.flex, t.flexRow],
  logo: [t.mR6],
};
